import UserEditionPage from '@/pages/admin/UserEditionPage/UserEditionPage.vue'

export default UserEditionPage
